var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9328 7.63407C23.8752 6.35625 23.6687 5.48195 23.3759 4.71814C23.0686 3.93031 22.6605 3.25777 21.9932 2.59484C21.3259 1.93191 20.6585 1.51398 19.8712 1.21133C19.1078 0.913496 18.234 0.711735 16.957 0.654089C15.6751 0.596443 15.2671 0.582031 12.012 0.582031C8.75215 0.582031 8.34407 0.596443 7.06701 0.654089C5.78996 0.711735 4.91618 0.9183 4.15283 1.21133C3.36067 1.51878 2.68854 1.92711 2.02601 2.59484C1.36347 3.26258 0.945791 3.93031 0.64333 4.71814C0.350471 5.48195 0.14403 6.35625 0.0864187 7.63407C0.0288072 8.9167 0.0144043 9.32503 0.0144043 12.582C0.0144043 15.8438 0.0288072 16.2522 0.0864187 17.53C0.14403 18.8078 0.350471 19.6821 0.64333 20.4459C0.950591 21.2338 1.35867 21.9063 2.02601 22.5692C2.68854 23.237 3.36067 23.6501 4.14803 23.9527C4.91138 24.2506 5.78516 24.4523 7.06221 24.51C8.34407 24.5676 8.75215 24.582 12.0072 24.582C15.2671 24.582 15.6751 24.5676 16.9522 24.51C18.2292 24.4523 19.103 24.2458 19.8664 23.9527C20.6537 23.6453 21.3259 23.237 21.9884 22.5692C22.6509 21.9015 23.0686 21.2338 23.3711 20.4459C23.6687 19.6821 23.8704 18.8078 23.928 17.53C23.9856 16.2474 24 15.839 24 12.582C24 9.32503 23.9904 8.9119 23.9328 7.63407ZM21.7772 17.4339C21.7243 18.6061 21.5275 19.245 21.3643 19.6629C21.1482 20.2201 20.8842 20.6237 20.4617 21.0464C20.0392 21.4691 19.6407 21.7237 19.079 21.9495C18.6565 22.1129 18.018 22.3098 16.8514 22.3627C15.5887 22.4203 15.2094 22.4347 12.0024 22.4347C8.79536 22.4347 8.41608 22.4203 7.15343 22.3627C5.982 22.3098 5.34347 22.1129 4.92579 21.9495C4.36887 21.7334 3.96559 21.4691 3.54311 21.0464C3.12063 20.6237 2.86617 20.2249 2.64053 19.6629C2.4773 19.2402 2.28046 18.6012 2.22765 17.4339C2.17004 16.1705 2.15563 15.791 2.15563 12.582C2.15563 9.37306 2.17004 8.99356 2.22765 7.73015C2.28046 6.55801 2.4773 5.9191 2.64053 5.50117C2.85657 4.94392 3.12063 4.5404 3.54311 4.11766C3.96559 3.69492 4.36407 3.44032 4.92579 3.21454C5.34827 3.05121 5.9868 2.85425 7.15343 2.80141C8.41608 2.74376 8.79536 2.72935 12.0024 2.72935C15.2094 2.72935 15.5887 2.74376 16.8514 2.80141C18.0228 2.85425 18.6613 3.05121 19.079 3.21454C19.6359 3.43071 20.0392 3.69492 20.4617 4.11766C20.8842 4.5404 21.1386 4.93912 21.3643 5.50117C21.5275 5.92391 21.7243 6.56282 21.7772 7.73015C21.8348 8.99356 21.8492 9.37306 21.8492 12.582C21.8492 15.791 21.83 16.1705 21.7772 17.4339Z",
    fill: "url(#paint0_linear_1868_10451)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0024 6.41406C8.59376 6.41406 5.83801 9.17627 5.83801 12.5822C5.83801 15.9929 8.59856 18.7503 12.0024 18.7503C15.4063 18.7503 18.1669 15.9833 18.1669 12.5822C18.1669 9.17147 15.4111 6.41406 12.0024 6.41406ZM12.0024 16.5838C9.794 16.5838 8.00325 14.792 8.00325 12.5822C8.00325 10.3724 9.794 8.5806 12.0024 8.5806C14.2109 8.5806 16.0016 10.3724 16.0016 12.5822C16.0016 14.792 14.2109 16.5838 12.0024 16.5838Z",
    fill: "url(#paint1_linear_1868_10451)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.407 7.61668C19.2024 7.61668 19.8473 6.97146 19.8473 6.17553C19.8473 5.3796 19.2024 4.73438 18.407 4.73438C17.6115 4.73438 16.9667 5.3796 16.9667 6.17553C16.9667 6.97146 17.6115 7.61668 18.407 7.61668Z",
    fill: "#BC30A0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1868_10451",
    x1: 20.2955,
    y1: 2.41723,
    x2: 2.93304,
    y2: 23.6896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE3DAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0468721,
    stopColor: "#B23BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#BD368E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2148,
    stopColor: "#CE2E69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#E62335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#FF1800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1868_10451",
    x1: 14.9423,
    y1: 7.63506,
    x2: 8.63493,
    y2: 18.2336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12F6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    stopColor: "#EA3751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3563,
    stopColor: "#F13D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5467,
    stopColor: "#F64133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#F7422F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7946,
    stopColor: "#F74C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8743,
    stopColor: "#F7652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9757,
    stopColor: "#F78F2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79A2E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6f5ec4d8770b89ee2e5be48216fc7cea.svg";
export { ForwardRef as ReactComponent };